import { useState } from 'react';
import { Element } from 'react-scroll/modules';
import { usePHSPACCResultsGame } from '@components/phs/pacc/results/query/useResults';
import GameWarning from './gameWarning';
import GameLink from './gameLink';
import GameTab from './gameTab';
import GameInfo from './gameInfo';
import GameNotice from './gameNotice';
import GameResult from './gameResult';
import TestGuideHeader from '../testGuideHeader';
import { PaccApplyResultVO } from '@domain/vo/phs/pacc/results/PaccApplyResultVO';
import { GameType } from '@domain/constant/acca/test/result/gameType';
import { AccTaskModuleEnum } from '@domain/constant/acca/TaskType';
import classNames from 'classnames/bind';
import styles from './gameGuide.module.scss';

const cx = classNames.bind(styles);

interface GameGuideProps {
  sn: number;
  applyResult: PaccApplyResultVO;
}

const GameGuide = ({ sn, applyResult }: GameGuideProps) => {
  const [gameTab, setGameTab] = useState<GameType>('RPS');
  const { data: gameResult } = usePHSPACCResultsGame(sn);

  if (!gameResult) return null;

  return (
    <Element name={AccTaskModuleEnum.GAME} className={cx('testGuideWrap')}>
      <TestGuideHeader moduleType={AccTaskModuleEnum.GAME} applyResult={applyResult} />

      <div className={cx('contentWrap')}>
        <div className={cx('contentBox')}>
          {/* [D] 전략 게임 분석 결과 영역 */}
          <GameResult feedbackType={gameResult.feedbackType} />
        </div>

        <div className={cx('contentBox')}>
          {/* [D] 경고 영역 */}
          <GameWarning gameTab={gameTab} gameResult={gameResult} />

          {/* [D] 탭 영역 */}
          <GameTab gameTab={gameTab} setGameTab={setGameTab} gameResult={gameResult} />

          {/* [D] 설명 영역 */}
          <GameInfo menu={'PRACTICE'} gameTab={gameTab} gameResult={gameResult} />

          {/* [D] 도움말 영역 */}
          <GameNotice />
        </div>

        {/* [D] 연습 바로가기 영역 */}
        <div className={cx('contentBox')}>
          <GameLink />
        </div>
      </div>
    </Element>
  );
};

export default GameGuide;
